export enum RadioOptionsEnum {
  PAYMENT_OPTIONS = 'PAYMENT_OPTIONS'
}
